import { render, staticRenderFns } from "./light-map-index.vue?vue&type=template&id=e9479cf6&scoped=true&"
import script from "./light-map-index.vue?vue&type=script&lang=js&"
export * from "./light-map-index.vue?vue&type=script&lang=js&"
import style0 from "./light-map-index.vue?vue&type=style&index=0&id=e9479cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9479cf6",
  null
  
)

export default component.exports